import { render } from "./badge-comp.vue?vue&type=template&id=998412f2&scoped=true"
import script from "./badge-comp.vue?vue&type=script&lang=js"
export * from "./badge-comp.vue?vue&type=script&lang=js"

import "./badge-comp.vue?vue&type=style&index=0&id=998412f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998412f2"]])

export default __exports__